module.exports = __webpack_public_path__ + "img/edit.d8a69b3e.svg";